/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-11-25 12:26:02
 * @LastEditTime: 2026-06-19 23:59:00
 * @Description:
 */

import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CompanyProfileSection from './components/CompanyProfileSection';
import TeamSection from './components/TeamSection';
import AchievementsSection from './components/AchievementsSection';
import ValuesSection from './components/ValuesSection';
import { useIsHongKongIp } from '../../hooks/useIsHongKongIp';

export default function AboutPage() {
  const { canShowRestrictedContent } = useIsHongKongIp();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <CompanyProfileSection />

        {/* 香港 / 美國 IP 不顯示；中國及其他地區照常顯示 */}
        {canShowRestrictedContent && <AchievementsSection />}

        <ValuesSection />

        {/* 香港 / 美國 IP 不顯示；中國及其他地區照常顯示 */}
        {canShowRestrictedContent && <TeamSection />}
      </main>
      <Footer />
    </div>
  );
}
